export enum TariffType {
  SPACE_SERVER = "Space-Server",
  PRO_SPACE = "proSpace",
  AGENCY_SERVER = "Agency-Server",
  CMS_HOSTING = "CMS-Hosting",
  SHOP_HOSTING = "Shop-Hosting",
}

export const isMStudioTariff = (tariffType: TariffType): boolean => {
  const mStudioTariffs = [TariffType.SPACE_SERVER, TariffType.PRO_SPACE];

  return mStudioTariffs.includes(tariffType);
};

export const isSingleProjectHosting = (tariffType: TariffType): boolean => {
  const singleProjectTariffTypes = [
    TariffType.PRO_SPACE,
    TariffType.CMS_HOSTING,
    TariffType.SHOP_HOSTING,
  ];

  return singleProjectTariffTypes.includes(tariffType);
};
